
export default function AuthoritySection() {
  return (
    <section id="authority" className="bg-white">
      <div className="py-24 px-6">
        <div className="max-w-6xl mx-auto">
          {/* セクションタイトル */}
          <div className="text-center mb-16">
            <div className="inline-flex items-center gap-3 mb-6">
              <span className="w-12 h-px bg-[#8B6BAE]"></span>
              <p className="text-sm tracking-[0.3em] text-[#8B6BAE] uppercase">Authority</p>
              <span className="w-12 h-px bg-[#8B6BAE]"></span>
            </div>
            <h2
              className="text-4xl md:text-5xl lg:text-6xl font-bold text-[#2C2C2C] mb-6 leading-tight"
              style={{ fontFamily: 'Playfair Display, serif' }}
            >
              <span className="text-[#8B6BAE]">現役イラストレーター</span>の
              <br />
              実作業で<span className="text-[#8B6BAE]">検証</span>
            </h2>
            <p className="text-base text-[#6B6B6B] font-light max-w-2xl mx-auto">
              医学的根拠に基づく角度設計を、実際の制作現場で徹底的に検証しました
            </p>
          </div>

          {/* 権威性カード */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            {/* 医学的根拠 */}
            <div className="bg-white border border-gray-100 rounded-lg p-6 hover:border-gray-200 transition-colors">
              <div className="w-10 h-10 flex items-center justify-center bg-gray-50 rounded-lg mb-4">
                <i className="ri-heart-pulse-line text-xl text-gray-700"></i>
              </div>
              <h3 className="text-base font-semibold text-gray-900 mb-2">
                医学的エビデンス
              </h3>
              <p className="text-sm text-gray-600 leading-relaxed mb-3">
                英国HSEガイドラインに基づく10°〜25°の推奨角度を採用
              </p>
              <p className="text-xs text-gray-400">
                手根管内圧を平常時レベルに維持
              </p>
            </div>

            {/* プロの声 */}
            <div className="bg-white border border-gray-100 rounded-lg p-6 hover:border-gray-200 transition-colors">
              <div className="w-10 h-10 flex items-center justify-center bg-gray-50 rounded-lg mb-4">
                <i className="ri-user-star-line text-xl text-gray-700"></i>
              </div>
              <h3 className="text-base font-semibold text-gray-900 mb-2">
                イラストレーターの実証
              </h3>
              <p className="text-sm text-gray-600 leading-relaxed mb-3">
                現役イラストレーターの実作業で検証を実施
              </p>
              <p className="text-xs text-gray-400">
                長時間作業での快適性を検証
              </p>
            </div>

            {/* 特許技術 */}
            <div className="bg-white border border-gray-100 rounded-lg p-6 hover:border-gray-200 transition-colors">
              <div className="w-10 h-10 flex items-center justify-center bg-gray-50 rounded-lg mb-4">
                <i className="ri-shield-check-line text-xl text-gray-700"></i>
              </div>
              <h3 className="text-base font-semibold text-gray-900 mb-2">
                独自構造
              </h3>
              <p className="text-sm text-gray-600 leading-relaxed mb-3">
                横向き：10°/20°/25° 横向き：30°/35° 縦向き：45°/75° ホバー：20°/65° 合計：9種類
              </p>
              <p className="text-xs text-gray-400">
                用途に応じた最適角度を実現
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* フルスクリーンブランドメッセージセクション */}
      <div className="relative w-full h-[100vh] min-h-[600px] overflow-hidden">
        {/* 背景画像 */}
        <div className="absolute inset-0">
          <img
            src="https://static.readdy.ai/image/05cd76bb9b80c0f39a77a9e694effa95/afae82a744283605e2825bf855ca85ef.jpeg"
            alt="Atelier Folio 創作シーン - iPadで描くクリエイター"
            title="Atelier Folio iPad Folio ケース 創作シーン"
            className="w-full h-full object-cover object-center"
          />
        </div>

        {/* グラデーションオーバーレイ */}
        <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-black/10 to-transparent"></div>

        {/* テキストオーバーレイ */}
        <div className="absolute inset-0 flex flex-col items-center justify-end pb-20 md:pb-28 px-6">
          <div className="text-center max-w-4xl mx-auto">
            <div className="inline-flex items-center gap-4 mb-6">
              <span className="block w-10 h-[1px] bg-white/20"></span>
              <i className="ri-quill-pen-line text-lg text-white/40 w-5 h-5 flex items-center justify-center"></i>
              <span className="block w-10 h-[1px] bg-white/20"></span>
            </div>
            <p
              className="text-3xl md:text-4xl lg:text-5xl font-semibold text-white tracking-wide leading-snug mb-4"
              style={{ fontFamily: 'Playfair Display, serif' }}
            >
              どんな瞬間も、<span className="text-[#D4B8E8]">創作の時間</span>に変える
            </p>
            <p className="text-sm md:text-base text-white/50 font-light tracking-wide">
              Atelier Folio — あなたのアトリエを、どこへでも。
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
